import Lightbox from './Lightbox';
import { lightboxSchemaFragment } from './schema';
import {
  defaultPalette,
  resolveBackdrop,
  rgbaString,
} from './palette';
import { resolveFullsizeSrc } from './helpers';
import { lightboxMessages } from './messages';
import { installLightbox } from './install';

export {
  Lightbox,
  lightboxSchemaFragment,
  defaultPalette,
  resolveBackdrop,
  rgbaString,
  resolveFullsizeSrc,
  lightboxMessages,
  installLightbox,
};

// Volto's addon machinery auto-imports each addon's default export and
// invokes it as `applyConfig(config)`. volto-lightbox has no auto-registration
// to perform (no blocks, no routes, no widgets that need wiring without
// consumer-supplied options). The actual configuration entry point is the
// named export `installLightbox(config, { defaultPaletteId })`, which the
// consumer calls from its own applyConfig with tenant-specific options.
// This default export exists only to satisfy Volto's structural requirement.
const applyConfig = (config) => config;
export default applyConfig;
